export default defineNuxtPlugin((nuxtApp) => {
	let $t = null

	nuxtApp.provide("messages", {
		$init: (t) => {
			$t = t
		},

		$loaded: () => {
			return !!$t
		},

		$t: (key, options) => $t(key, options),
	})
})
